var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',[_vm._v(_vm._s(_vm.selected===_vm.to?"☛":""))]),_c('a',{attrs:{"href":_vm.to},on:{"click":function($event){$event.preventDefault();return _vm.change($event)}}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }